export default __webpack_public_path__ + "static/media/oreilly.a41b67be.jpg";